import React, { useEffect } from 'react'
import { useParams } from "react-router";
import t from '../../service/translate.service'
import LoadingPageOverlay from '../../components/LoadingPageOverlay'
import { Alert } from 'antd'
import { useState } from 'react';
import MagicLinkStore from '../../store/magicLink.store';
import { extractError } from '../../service/response.service';
import { b2cPolicies } from '../../azureB2C/authConfig';
import { useMsal } from '@azure/msal-react';
import { useTheme } from '../../providers/ThemeProvider';

export const MagicLinkProceed = () => {
  const [loading, setLoading] = useState(true)
  const { instance } = useMsal()
  const { activeMagnifier } = useTheme()
  const [error, setError] = useState(true)
  const params = useParams()
  const magicLinkStore = new MagicLinkStore()
  const language = localStorage.getItem("locale") || "de";
  useEffect(() => {
    (async () => {
      try {
        localStorage.removeItem('path')
        const res = await magicLinkStore.magicLinkVerification(params?.value || '')
        switch (res?.type) {
          case 'contractSigningFeature':
            await instance.acquireTokenRedirect({
              ...b2cPolicies.authorities.emailSignUp,
              redirectStartPage: '/',
              state: JSON.stringify({
                activateEmail: true,
                contractCreation: true
              }),
              extraQueryParameters: {
                ui_locales: `${language}`,
                magnifier: activeMagnifier.value,
                firstName: res?.firstName ? encodeURIComponent(res?.firstName) : '',
                lastName: res?.lastName ? encodeURIComponent(res?.lastName) : '',
                email: res?.email ? encodeURIComponent(res?.email) : '',
                phone: res?.phone ? encodeURIComponent(res?.phone) : '',
                type: res?.type ? encodeURIComponent(res?.type) : ''
              },
            }).then((res) => {
              console.log(res, 1)
            })
            .catch((err) => {
              console.log(err, 1)
            })
            break;
          default:
            throw new Error('MAGIC_LINK_WRONG_TYPE')
        }
      } catch (error) {
        console.log(error)
        setError(t[extractError(error)] || t["ERROR"])
      }
      setLoading(false)
    })()
  }, [])

  if (loading) {
    return <LoadingPageOverlay />
  }
  
  return (
    <div className='wrapper'>
      {error && <Alert message={error} type='error' style={{marginTop: '12px', marginBottom: '12px'}} />}
    </div>
  )
}
